<script setup lang="ts">
import './assets/style.scss'
import { useCabinetInit } from '../model/api'
import { useConfirm } from '@/shared/ui'
import { useSseConnection, useTranslate } from '@/shared/lib'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { DateTime } from 'ts-luxon'
import { useAuth } from '@/entities/Auth'

const { show } = useConfirm()
const { trs } = useTranslate()
const route = useRoute()
const auth = useAuth()

const { send, isPending } = useCabinetInit()

/**
 * Функция обработки отправки команды
 * @param type
 */
const clickHandler = (type: string) => {
  show({
    title: trs('itf.confirm_command'),
    confirmFunc: () => send(type),
  })
}

const resultTimeCommand = ref<Object>('')

/** Обработка SSE данных */
const { handler } = useSseConnection((res: { time: string }) => {
  if (!res.time) return

  const time = new Date(res.time.replace('GMT+00:00', '')).getTime()
  resultTimeCommand.value = DateTime.fromMillis(time)
    .setLocale(auth.user?.lang || 'ru')
    .toFormat('dd.LL.y HH:mm:ss')
})

watch(
  () => route.params.object_id,
  () => {
    handler(`/cabinets/${route.params.object_id}/statuses`)

    resultTimeCommand.value = ''
  },
  { immediate: true },
)
</script>

<template>
  <div class="admin-commands__grid">
    <div class="admin-commands">
      <div
        class="admin-commands__item"
        :class="{ disabled: !auth.isPermissions(['DEVICE_CONTROL']) }"
      >
        <p>{{ $t('itf.init') }}</p>

        <VBtn @click="clickHandler('init')" :loading="isPending">{{ $t('itf.run') }}</VBtn>
      </div>

      <div
        class="admin-commands__item"
        :class="{ disabled: !auth.isPermissions(['DEVICE_CONTROL']) }"
      >
        <p>{{ $t('itf.get_status') }}</p>

        <VBtn @click="clickHandler('state')" :loading="isPending">{{ $t('itf.run') }}</VBtn>
      </div>

      <div
        class="admin-commands__item"
        :class="{ disabled: !auth.isPermissions(['DEVICE_CONTROL']) }"
      >
        <p>{{ $t('itf.current_time') }}</p>

        <VBtn @click="clickHandler('time')" :loading="isPending">{{ $t('itf.run') }}</VBtn>
      </div>

      <div
        class="admin-commands__item"
        :class="{ disabled: !auth.isPermissions(['DEVICE_CONTROL']) }"
      >
        <p>{{ $t('itf.send_schedule') }}</p>

        <VBtn @click="clickHandler('schedule')" :loading="isPending">{{ $t('itf.run') }}</VBtn>
      </div>
    </div>

    <div class="admin-commands__time">
      <p class="text-h6 font-weight-regular mb-2">{{ $t('itf.time_machine') }}</p>
      {{ resultTimeCommand || $t('itf.not_info').toLowerCase() }}
    </div>
  </div>
</template>
